import { Button, Stack } from '@mui/material'
import { formatPlanPeriod, formatPlanPrice, usePlanConfig } from 'hooks/usePublicConfig'
import { TRAINEE_PLAN } from 'types'
import { AuthFormTitle } from '../AuthFormTitle/AuthFormTitle'
import { RegistrationChoiceOption } from '../RegistrationChoiceOption/RegistrationChoiceOption'

/**
 * Second step of trainee registration: the two ways to get access are presented as equal options.
 * Before this screen existed, purchasing was hidden behind a "No Code? Pay with Card" button on the
 * access-code form, which read as a fallback rather than a choice.
 */
export function TraineeRegistrationChoice({
  onUseAccessCode,
  onPurchase,
  onCancel,
}: {
  onUseAccessCode: () => void
  onPurchase: () => void
  onCancel: () => void
}) {
  const plan = usePlanConfig(TRAINEE_PLAN)

  const priceLine = plan
    ? `${formatPlanPrice(plan)} per ${formatPlanPeriod(plan)}, renews automatically`
    : 'Pay by credit card, renews automatically'

  return (
    <Stack direction="column" spacing={2}>
      <AuthFormTitle textColor="secondary.main" mb={0}>
        How would you like to get access?
      </AuthFormTitle>

      <RegistrationChoiceOption
        title="I have an Institutional Access Code"
        description="Your organization gave you a code to register with."
        onClick={onUseAccessCode}
      />

      <RegistrationChoiceOption
        title="Purchase an Individual Trainee Subscription"
        description={priceLine}
        onClick={onPurchase}
      />

      <Stack alignItems="center" pt={1}>
        <Button onClick={onCancel} variant="outlined" color="info" sx={{ minWidth: 200 }}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  )
}
